import React, { useState, useContext, useEffect, Fragment } from 'react'
import { PageContext } from '../../Context/PageProvider'
import { makeStyles } from '@material-ui/core/styles'
import { DefaultStyles } from '../../Stylesheet/theme'
import { withTranslation } from 'react-i18next'
import { Grid, Select, Input, FormGroup, FormControlLabel, Checkbox, MenuItem, InputLabel, FormControl, Button } from '@material-ui/core'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import Modal from './Modal'
import PasswordModal from './PasswordModal'

function UserModal({ t, user, open, onClose }) {
    const classes = useStyles()
    const context = useContext(PageContext)
    const api = context.api
    const orgs = context.orgs
    const [editUser, setEditUser] = useState(null)
    const [loading, setLoading] = useState(false)
    const [roles, setRoles] = useState(null)
    const [selectedRoles, setSelectedRoles] = useState([])
    const [changePassword, setChangePassword] = useState(false)



    if (editUser === null) {
        setEditUser(user ? { ...user } : { firstname: '', lastname: '', username: '', password: '', passwordVerify: '', roles: [], active: true })
    }

    const onSubmit = async () => {
        try {
            setLoading(true)
            editUser.roles = selectedRoles
            user ? await api.adminService.updateUser(editUser) : await api.adminService.registerUser(editUser)
            setTimeout(() => {
                onClose()
            }, 500)
        } catch (error) {
            console.log('Category Modal Error,', error)
        }
    }

    const getRoles = async () => {
        try {
            const roleList = await api.adminService.getRoles()
            setRoles(roleList)
            user && setSelectedRoles(user.roles)
        } catch (error) {
            console.log(error)
        }
    }

    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
        if (value !== editUser.password) {
            return false
        }
        return true
    })

    useEffect(() => {
        getRoles()
    }, [])

    if (editUser === null || roles === null || orgs === null) return null
    return (
        <Fragment>
            <Modal open={open} aria-labelledby="user-modal" title={user ? t('edit_user') : t('new_user')} onSubmit={onSubmit} onCancel={onClose} loading={loading}>
                <Grid container>
                    <Grid item className={classes.fields}>
                        <TextValidator
                            label={t('email')}
                            onChange={(event) => { const value = event && event.target && event.target.value; setEditUser(prevState => ({ ...prevState, username: value })) }}
                            name="email"
                            type="text"
                            validators={['required', 'isEmail']}
                            errorMessages={[t('this_field_is_required'), t('invalid_email')]}
                            value={editUser.username}
                            disabled={loading}
                            InputProps={user ? {
                                readOnly: true,
                                disableUnderline: true
                            } : null}
                        />
                    </Grid>
                    <Grid item className={classes.fields}>
                        <TextValidator
                            label={t('first_name')}
                            onChange={(event) => { const value = event && event.target && event.target.value; setEditUser(prevState => ({ ...prevState, firstname: value })) }}
                            name="firstname"
                            type="text"
                            validators={['required']}
                            errorMessages={[t('this_field_is_required')]}
                            value={editUser.firstname}
                            disabled={loading}
                        />
                    </Grid>
                    <Grid item className={classes.fields}>
                        <TextValidator
                            label={t('last_name')}
                            type="text"
                            name="lastname"
                            value={editUser.lastname}
                            validators={['required']}
                            errorMessages={[t('this_field_is_required')]}
                            onChange={(event) => { const value = event && event.target && event.target.value; setEditUser(prevState => ({ ...prevState, lastname: value })); }}
                            disabled={loading}
                        >
                        </TextValidator>
                    </Grid>

                    {
                        !user || user && !user.isAdmin ?
                            < Grid item className={classes.fields}>
                                <FormControl>
                                    <InputLabel id="roles-label">{(t('roles'))}</InputLabel>
                                    <Select
                                        multiple
                                        labelId="roles-label"
                                        label={t('roles')}
                                        value={selectedRoles}
                                        onChange={(event) => setSelectedRoles(event.target.value)}
                                        input={<Input />}
                                        renderValue={(selected) => {
                                            const titles = []
                                            selected.map(selectedId => {
                                                const role = roles.find(role => role._id === selectedId)
                                                role ? titles.push(role.title) : titles.push(selectedId)
                                            })
                                            return titles.join(', ')

                                        }}
                                    >
                                        {roles.map((role) => (
                                            <MenuItem key={role._id} value={role._id}>
                                                <Checkbox checked={selectedRoles.indexOf(role._id) > -1} />
                                                {role.title}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid> : null

                    }
                    {
                        user ?
                            <Fragment>
                                <Grid item className={classes.fields}>
                                    <Button onClick={() => setChangePassword(true)} disabled={loading} variant="outlined" color="primary">{t('change_password')}</Button>
                                </Grid>
                            </Fragment>
                            :
                            <Fragment>
                                <Grid item className={classes.fields}>
                                    <TextValidator
                                        label={t('password')}
                                        name="password"
                                        type="password"
                                        onChange={(event) => { const value = event && event.target && event.target.value; setEditUser(prevState => ({ ...prevState, password: value })) }}
                                        validators={['required']}
                                        errorMessages={[t('this_field_is_required')]}
                                        value={editUser.password}
                                        disabled={loading}
                                    />
                                </Grid>
                                <Grid item className={classes.fields}>
                                    <TextValidator
                                        label={t('repeat_password')}
                                        name="passwordVerify"
                                        type="password"
                                        onChange={(event) => { const value = event && event.target && event.target.value; setEditUser(prevState => ({ ...prevState, passwordVerify: value })) }}
                                        validators={['isPasswordMatch', 'required']}
                                        errorMessages={[t('passwords_do_not_match'), t('this_field_is_required')]}
                                        value={editUser.passwordVerify}
                                        disabled={loading}
                                    />
                                </Grid>
                            </Fragment>
                    }
                </Grid>

                {
                    editUser && !editUser.isSuperAdmin && context.user._id !== editUser._id &&

                    <Grid container className={classes.activeCheckGrid}>
                        <Grid item>
                            <FormGroup row>
                                <FormControlLabel
                                    control={<Checkbox
                                        checked={editUser.active}
                                        onChange={(event) => { const value = event && event.target && event.target.checked; setEditUser(prevState => ({ ...prevState, active: value })) }}
                                        inputProps={{ 'aria-label': 'active check' }}
                                        disabled={loading}
                                    />}
                                    label={t('active')} />
                            </FormGroup>

                        </Grid>
                    </Grid>
                }

            </Modal >
            {
                changePassword && <PasswordModal
                    open={true}
                    userId={user._id}
                    onClose={() => {
                        setChangePassword(false)
                    }}
                />
            }
        </Fragment >
    )
}

const useStyles = makeStyles(theme => ({
    fields: {
        ...DefaultStyles.ModalFields,
        marginBottom: theme.margin.medium,
        marginRight: 0
    },
    activeCheckGrid: {
        marginBottom: theme.margin.small,
        '& span': {
            color: theme.palette.primary.main,
            fontWeight: theme.font.weight.normal
        }
    }
}))

export default (withTranslation()(UserModal))